module.exports = __webpack_public_path__ + "img/ic_arrow_down.a743ab9f.svg";